export default function StarIcon ({ strokeColor = "black", size = "20"}) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20" fill="none">
<path d="M9.9974 1.66797L12.5724 6.88464L18.3307 7.7263L14.1641 11.7846L15.1474 17.518L9.9974 14.8096L4.8474 17.518L5.83073 11.7846L1.66406 7.7263L7.4224 6.88464L9.9974 1.66797Z" 
stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
    );
    
}